module.exports = __webpack_public_path__ + "static/media/card-wifi.bc5c86b6.png";